import { render, staticRenderFns } from "./ConnectionTypeDetail.vue?vue&type=template&id=6d10cda4&scoped=true"
import script from "./ConnectionTypeDetail.vue?vue&type=script&lang=js"
export * from "./ConnectionTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./ConnectionTypeDetail.vue?vue&type=style&index=0&id=6d10cda4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10cda4",
  null
  
)

export default component.exports